import { Component, OnInit } from '@angular/core';
import { HttpErrorResponse } from '@angular/common/http';
import { MatDialog, MAT_DIALOG_DATA, MatDialogRef } from '@angular/material/dialog';
import { FormGroup, FormBuilder, Validators } from '@angular/forms';
import { environment } from 'src/environments/environment';
import { CommonService } from 'src/app/services/common-services/common.service';
import { ToastrService } from 'ngx-toastr';
import * as EmailValidator from 'email-validator';

@Component({
  selector: 'app-get-quote',
  templateUrl: './get-quote.component.html',
  styleUrls: ['./get-quote.component.scss']
})
export class GetQuoteComponent implements OnInit{
  dialog:any;
  quoteForm!: FormGroup;
  selectedValueControl = localStorage.getItem('category_value');;
  baseUrl = environment.BASE_URL;
  countryData:  any[] = [];
  industryData: any[] = [];
  categoryData: any[] = [];
  enquiryData: any[] = [];
  constructor(
    public fb: FormBuilder,
    private service : CommonService,
    public dialogRef: MatDialogRef<GetQuoteComponent>,
    private toastr: ToastrService
  )
  { 
    dialogRef.disableClose = true;
   }
  

  ngOnInit() {
    this.quoteForm = this.fb.group({
      name: ['', [Validators.required, Validators.minLength(4)]],
      //companyEmail: ['', [Validators.required, this.validateEmail()]],
      companyEmail: ['', Validators.required],
      countryCode: ['+91', Validators.required],
      mobile: ['', [Validators.required, Validators.pattern('^[1-9][0-9]{9}$')]],
      company: ['', Validators.required],
      country: ['', Validators.required],
      industry: ['0'],
      category: ['', Validators.required],
    });

    this.getCountry();
    this.getIndustry();
    this.getCategory();
    this.getEnquiry();
  }

  get validateEmail(){
    return EmailValidator.validate(this.quoteForm.value.companyEmail); 
  }

  getEnquiry(){
    this.service.getData(`${this.baseUrl}common-service/enquiry-management`).subscribe(res => {
      this.enquiryData = res?.response;
      console.log(this.enquiryData)
    })
  }
  getCountry() {
    this.service.getData(`${this.baseUrl}common-service/country-management`).subscribe(res => {
      this.countryData = res?.response;
      //console.log(this.countryData)
    })
  }
  getIndustry() {
    this.service.getData(`${this.baseUrl}common-service/industry-management`).subscribe(res => {
      this.industryData = res?.response;
    })
  }
  getCategory() {
    this.service.getData(`${this.baseUrl}common-service/category-management`).subscribe(res => {
      this.categoryData = res?.response;
    })
  }

  quoteSubmit(){
    let userDetail = {
      userName: this.quoteForm.value.name,
      email: this.quoteForm.value.companyEmail,
      status: true,
      company: this.quoteForm.value.comapny,
      phone: this.quoteForm.value.countryCode+' '+ this.quoteForm.value.mobile,
      userType: "Customer",
      source: "WEB",
      role: "Customer",
      address: ''
    }
    let lead = {
      industryName: this.quoteForm.value.industry[1],
      categoryName: this.quoteForm.value.category[1],
      categoryId: this.quoteForm.value.category[0],
      countryId: this.quoteForm.value.country[0],
      countryName: this.quoteForm.value.country[1],
      industryId: this.quoteForm.value.industry[0],
      status: true
    }
    let customerCompanyProfile = {
      name: this.quoteForm.value.company,
      address: this.quoteForm.value.comapny,
      stateId: '',
      stateName: '',
      cityId: '',
      cityName: '',
      pincodeId: 11,
      pincode: '456001'
    }
    this.service.postDatawithoutHeaders(`${this.baseUrl}auth-service/signUp`, { userDetail, lead, customerCompanyProfile }).subscribe({
        next: (res:any) => {
            this.toastr.success('Form submitted successfully!');
            this.quoteForm.reset();
            this.closeDialog();
        },
        error: (error: HttpErrorResponse) => {
          if(error.error.status.error.message === 'User Already Exist'){
            this.toastr.warning(error.error.status.error.message);
          } else{
            this.toastr.error(error.error.status.error.message);
          }
        }
    })
  }
  isValid() {
    if (this.quoteForm.controls['name'].status === 'INVALID' || this.quoteForm.controls['companyEmail'].status === 'INVALID' || this.quoteForm.controls['mobile'].status === 'INVALID' || this.quoteForm.controls['company'].status === 'INVALID' || this.quoteForm.controls['country'].status === 'INVALID' || this.quoteForm.controls['category'].status === 'INVALID')  {
      return true;
    } else {
      return false;
    }
  }
  openDialog(enterAnimationDuration: string, exitAnimationDuration: string): void {
    this.dialog.open(GetQuoteComponent, {
      //width: '700px',
      enterAnimationDuration,
      exitAnimationDuration,
    });
  }
  closeDialog(){
    this.dialogRef.close();
    localStorage.removeItem('category_value');
    this.quoteForm.reset();
  }
}
